import { useMemo } from 'react';
import { cn } from '@/lib/utils';

export type OficinaMercosulPlateProps = {
  placa: string | null | undefined;
  className?: string;
};

/** Placa estilo Mercosul em duas linhas (faixa BRASIL + corpo branco), como no padrão quadrado/moto. */
export function OficinaMercosulPlate({ placa, className }: OficinaMercosulPlateProps) {
  const { line1, line2, label } = useMemo(() => {
    const raw = (placa ?? '').replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    if (!raw) {
      return { line1: '—', line2: '—', label: 'Placa indisponível' };
    }
    if (raw.length <= 3) {
      return { line1: raw, line2: '', label: placa ?? raw };
    }
    return {
      line1: raw.slice(0, 3),
      line2: raw.slice(3),
      label: placa ?? raw,
    };
  }, [placa]);

  return (
    <div
      className={cn(
        'w-[7.5rem] shrink-0 overflow-hidden rounded-lg border border-neutral-300 bg-white shadow-sm',
        'dark:border-neutral-500 dark:bg-neutral-50',
        className
      )}
      role="img"
      aria-label={`Placa ${label}`}
    >
      <div className="bg-[#002776] py-[6px] text-center text-[16px] font-bold uppercase leading-none tracking-wide text-white">
        BRASIL
      </div>
      <div className="flex flex-col items-center justify-center px-1 py-3 text-center">
        <span className="block font-black leading-none text-black [font-family:system-ui,-apple-system,sans-serif] text-[26px] tracking-tight">
          {line1}
        </span>
        <span className="mt-1 block min-h-[0.85em] font-black leading-none text-black [font-family:system-ui,-apple-system,sans-serif] text-[26px] tracking-tight">
          {line2 || '\u00A0'}
        </span>
      </div>
    </div>
  );
}
